
















import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import { Quote } from '@/modules/Quote/interfaces/quote'
import FoldingCard from '@/components/FoldingCard.vue'
import AppFileUploader from '@/components/AppFileUploader.vue'
import S3Handler from '@/mixins/s3'
import { AcordForm } from '@/modules/AcordForm/interfaces/acord-form'
import AcordFormDialog from '@/components/AcordFormDialog.vue'
import AcordFormList from '@/components/AcordFormList.vue'
import { RecordType } from '@/modules/RecordType/interfaces/record-type'

@Component({
  components: {
    FoldingCard,
    AppFileUploader,
    AcordFormDialog,
    AcordFormList
  }
})
export default class QuoteAcordForm extends mixins(S3Handler) {
  @Prop({ type: Object as () => Quote }) readonly quote!: Quote
  @Prop({ type: Object as () => RecordType }) readonly recordType!: RecordType

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay

  acordFormDialog = {
    show: false
  }

  get acordForms () {
    if (!this.quote) {
      return []
    }

    const list = this.quote.acordForms.concat()

    list.sort(function (a: AcordForm, b: AcordForm) {
      return b.version - a.version
    })

    const groupedObj = this.$R.groupBy((file: AcordForm) => {
      return file.acordFormId
    })(list)

    let acordList: AcordForm[] = []

    const diff = (a: string, b: string) => { return Number(b) - Number(a) }

    for (const key of this.$R.sort(diff, this.$R.keys(groupedObj))) {
      acordList = [...groupedObj[key], ...acordList]
    }

    return acordList
  }

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  @Emit('edit')
  editQuote (step: number) {
    return step
  }

  routeToDetail (item: any) {
    this.$router.push({
      name: 'PolicyDetailDetail',
      params: {
        id: item.id
      }
    })
  }

  showAcordFormDialog (e: Event) {
    e.preventDefault()
    e.stopPropagation()

    this.acordFormDialog.show = true
    this.onSuccess()
  }
  hideAcordFormDialog () {
    this.acordFormDialog.show = false
  }

  stopPreventDefault (e: Event) {
    e.preventDefault()
    e.stopPropagation()
  }

  mergeCellMethod ({ row, _rowIndex, column, visibleData }: any) {
    const fields = ['name']
    const cellValue = row[column.property]
    if (cellValue && fields.includes(column.property)) {
      const prevRow = visibleData[_rowIndex - 1]
      let nextRow = visibleData[_rowIndex + 1]
      if (prevRow && prevRow['acordFormId'] === row['acordFormId']) {
        return { rowspan: 0, colspan: 0 }
      } else {
        let countRowspan = 1
        while (nextRow && nextRow['acordFormId'] === row['acordFormId']) {
          nextRow = visibleData[++countRowspan + _rowIndex]
        }
        if (countRowspan > 1) {
          return { rowspan: countRowspan, colspan: 1 }
        }
      }
    }
  }

  cellClassName (data: any) {
    if (data.column.property === 'name') {
      return 'file-name-cell'
    }
  }
}
